import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomPlaylistOutlined = createSvgIcon(
  <path d="M5 2.296a1.8 1.8 0 0 1 2.042.045l12 7.814c.583.402.958 1.116.958 1.83 0 .76-.375 1.474-.958 1.832l-12 7.858c-.625.402-1.417.447-2.042.045-.625-.357-1-1.072-1-1.875V4.127c0-.76.375-1.474 1-1.831m1 17.549 12-7.86L6 4.128v15.718Z" />,
  'CustomPlaylistOutlined',
);

export default CustomPlaylistOutlined;
